import React from "react";
// Assuming Files is at src/Files based on original relative path from EnvFiles.js (which was at src/)
import DocumentForm from "../../Files/DocumentForm"; 

const DocumentFormOffcanvas = ({
  isOpen,
  handleClose,
  selectedDoc,
  formData,
  setFormData,
  commonFields,
  documentFields,
  handleSubmit,
}) => {
  return (
    <div
      className={`offcanvas offcanvas-end ${isOpen ? "show" : ""}`}
      tabIndex="-1"
      id="formOffcanvas"
      style={{ visibility: isOpen ? "visible" : "hidden", minWidth: "50%" }}
    >
      <DocumentForm
        doc={selectedDoc}
        storedFileName={selectedDoc?.file_name}
        formData={formData}
        setFormData={setFormData}
        onClose={handleClose}
        commonFields={commonFields}
        documentFields={documentFields}
        onSubmit={handleSubmit}
        isEdit={selectedDoc?.hasDetails || false}
        isViewOnly={false}
      />
    </div>
  );
};

export default DocumentFormOffcanvas;
